export default {
    title: "AELU",
    ssv: "विशिष्ट कौशल भिसा",
    what_ssv: "विशिष्ट कौशल भिसा",
    representative_message: "प्रतिनिधि सन्देश",
    aeru_feature: "AELU का सुविधाहरू",
    aeru_how_to_use: "प्रयोगको प्रवाह",
    aeru_q_a: "प्रश्नोत्तर",
    aeru_function: "AELU का कार्यहरू",
    aeru_fee: "AELU शुल्क",
    login: "लग - इन",
    db_top_comment1: "उद्योग मा पहिलो! विशिष्ट कौशल भिसा परीक्षा को लागी स्मार्टफोन अनलाइन प्रशिक्षण साइट।",
    db_top_comment2: "AELU एक वेब सेवा हो जसले परीक्षा, परीक्षा जानकारी, र अनुप्रयोग एजेन्सीको लागि अध्ययन गरेर विशिष्ट कौशल भिसाको अधिग्रहणलाई समर्थन गर्दछ।",
    db_top_pr: "नयाँ अवसरहरू प्रयोग गर्न तपाईंको विशिष्ट कौशल भिसा प्रयोग गर्नुहोस्।",
    member_regist: "सदस्य पञ्जीकरण",
    registration_support_organization: "एउटा दर्ता समर्थन संगठन के हो?",
    rso_dec1: "विशेष कौशल प्रणालीमा दुई संगठनहरू हुन्छन्, विशिष्ट कौशल सम्बद्ध संगठन र दर्ता समर्थन संगठन। एक विशिष्ट कौशल सम्बद्ध संगठन एक कम्पनी हो (संगठन स्वीकार गर्दै) विशिष्ट कौशलको साथ विदेशमा रोजगार। विशिष्ट कौशल सम्बन्धित संस्थाले कार्यस्थल, दैनिक जीवन, र समाजमा विशिष्ट सीपहरूको साथ विदेशियाहरूलाई सहयोग प्रदान गर्नुपर्दछ।",
    rso_dec2: "विशिष्ट कौशल भएका विदेशीहरूलाई सहयोग पुर्‍याउने सन्दर्भमा विशेष सामग्रीहरू भएकाले त्यहाँ त्यस्तो अवसरहरू छन् जहाँ कम्पनीलाई विशिष्ट सीपहरूसहित विदेशमा काम गर्ने कम्पनीलाई सहयोग पुर्‍याउने संस्था जससँग विशिष्ट सीप हुन्छ। रेजिष्ट्रेसन समर्थन संगठन भनेको एक त्यस्तो संगठन हो जुन विशेष सीप सम्बद्ध संगठनलाई सुम्पिएको हुन्छ जुन विशिष्ट कौशल भएका विदेशीहरूका लागि समर्थन योजना सिर्जना र कार्यान्वयन गर्न।",
    rso_dec3: "रेजिष्ट्रेसन समर्थन संगठन भनेको एक त्यस्तो संगठन हो जुन विशेष सीप सम्बद्ध संगठनलाई सुम्पिएको हुन्छ जुन विशिष्ट कौशल भएका विदेशीहरूका लागि समर्थन योजना सिर्जना र कार्यान्वयन गर्न।",
    rso_dec4: "पंजीकरण समर्थन संगठन होस्ट संगठन संग एक समर्थन खेप सम्झौताको माध्यमबाट नम्बर १ निर्दिष्ट निर्दिष्ट एलियन समर्थन योजनामा आधारित सबै समर्थन प्रदान गर्दछ।",
    rso_dec5: "A दर्ता समर्थन संगठन बन्नको लागि, तपाईंलाई जापानको अध्यागमन ब्यूरोको आयुक्तले दर्ता गर्न आवश्यक छ।",
    rso_dec6: "○ दर्ता भएका संस्थाहरू दर्ता समर्थन संगठन दर्तामा दर्ता हुनेछन् र जापानको अध्यागमन ब्यूरोमा पोस्ट गरिनेछ।",
    rso_dec7: "Registration दर्ता अवधि years बर्ष हो र यसलाई नविकरण गर्नु आवश्यक छ।",
    rso_dec8: "○ दर्ता समर्थन संगठनहरूले कुनै पनि समयमा जापानको अध्यागमन ब्यूरोमा विभिन्न सूचनाहरू पेश गर्न आवश्यक छ।",
    article1: "एक विशिष्ट कौशल भिसा के हो?",
    article1_dec1: "डिसेम्बर,, २०१ 2018 मा संशोधित अध्यागमन नियन्त्रण ऐनको लागूको साथ, निवास विशिष्ट कौशलको स्थिति नयाँ स्थापना भयो। अप्रिल २०१ in मा लागू गरिएको।",
    article1_dec2: "निवास विशिष्ट कौशलको नयाँ स्थिति दुई चरणमा स्थापना गरिनेछ। (न। १ र न। २)",
    article1_dec3: "लक्षित उद्योगहरू १ industries उद्योग हुन्।",
    article1_dec4: "लक्षित विदेशीहरूको आवश्यकता भनेको एक व्यक्ति हो जससँग सीपहरू छन् जसमा पर्याप्त ज्ञान वा अनुभव आवश्यक पर्दछ। अर्को शब्दमा, जसले तीन वर्षको टेक्निकल इन्टर्नल प्रशिक्षण पूरा गरिसकेका छन् वा जसले बराबर जापानी भाषा र प्रवीणता परीक्षा पास गरेका छन् तिनीहरू योग्य छन्।",
    article1_dec5: "विशिष्ट कौशल नं। १ लाई skills बर्ष सम्म निश्चित सीपको व्यक्तिको रूपमा रहन अनुमति छ। परिवारका सदस्यहरूलाई अनुमति छैन।",
    article1_dec6: "एक कुशल सीप संग एक व्यक्ति को रूप, विशिष्ट कौशल नं। 2 विशिष्ट कौशल नं। १ को अवधिमा एक विशेष परीक्षा पारित गरेर सामान्य रोजगारको बराबर निवासको स्थिति दिइन्छ। स्थायी रूपमा, र तपाईं आफ्नो परिवार ल्याउन सक्नुहुन्छ।),",
    article2: "प्रतिनिधि सन्देश",
    article2_sub1: "अझै जापान छोड्नुहोस्",
    article2_dec1: "हामी धेरै प्राविधिक इंटर्न प्रशिक्षार्थीहरु र फिर्ती प्रशिक्षार्थीहरु प्रति हार्दिक आभार व्यक्त गर्न चाहन्छौं जो जापानमा प्राविधिक इंटर्न प्रशिक्षुको रूपमा आएका थिए, सीप प्राप्त गरे, र आफ्नै देशको विकासको लागि कुनै कसर बाँकी राखेनन्। मलाई लाग्छ कि परिवार र स्वदेशका लागि अभ्यास गर्ने उपस्थिति जुन आज जापानमा छैन, त्यो मूल मानव उपस्थिति हो। म लामो समयदेखि टेक्निकल इन्टर्नल ट्रेनिंग व्यवसायमा संलग्न भएता पनि त्यहाँ टेक्निकल इन्टर्न ट्रेनी भिसा लिएर मात्र प्रवेश गर्ने कुनै तरिका छैन, र म त्यो अवसरको फाइदा लिन्छु, जापानमा दृढतापूर्वक अभ्यास गर्ने, मेरो व्यवसाय खोल्ने मेरो आफ्नै देश, र मेरो देशको विकास हुँदै गइरहेको मैले धेरै देखे। जे होस्, अप्रिल २०१ in मा, भिसा विशिष्ट कौशल भिसा निर्माण गरिएको थियो, जसले जापानको आनन्द लिने इच्छालाई पूरा गर्दछ, जुन निर्धारित वर्षहरूमा पूर्ण रूपमा सिक्न सकिदैन। मलाई आशा छ कि जापान भ्रमण गर्ने धेरै विदेशीहरूले आफ्नो आँखाको पछाडि महत्वाकांक्षा राखेका छन्, जो जापानमा दुर्लभ छन्, सँगै जापानको विकास गर्न सक्दछन्। सबैभन्दा माथि म चाहन्छु कि जापान जस्ता व्यक्तिहरु संग रहोस्, स्थायी बासिन्दाहरुको संख्या बृद्धि होस्, र एकसाथ बस्न सक्ने एउटा समाज बनाउनु पर्छ।",
    article2_dec2: "भिजुअलाइजेशन कं, लिमिटेड",
    article2_dec3: "राष्ट्रपति र मुख्य कार्यकारी अधिकारी",
    article2_dec4: "काजुहुको होरिउचि",
    article3: "तीन सुविधाहरू AELU द्वारा प्रदान गरिएको",
    article3_sub1: "अनलाइन परीक्षाको लागि अध्ययन गर्दै",
    article3_sub1_dec1: "एईएलयू, जसले तपाईंलाई तपाईंको स्मार्टफोनमा विशिष्ट कौशल परीक्षणको लागि तयारी गर्न अनुमति दिन्छ, विगत प्रश्नहरू सहित सबै १ industries उद्योगहरूमा questions० प्रश्नपश्चात पछाडि स्यूडो-प्रश्नहरू तयार गर्दछ, र तपाईं परीक्षा मिति तिर जति पटक चाहानुहुन्छ उपायहरू लिन सक्नुहुन्छ। यदि तपाईं एआई द्वारा पप आउट गरिएका प्रश्नहरूको लागि निर्दिष्ट स्कोर पार गर्नुभयो भने, तपाईं निश्चय पनि परीक्षामा सफल हुनुहुनेछ!",
    article3_sub2: "परीक्षा जानकारी",
    article3_sub2_dec1: "जापानका लागि विदेशी पर्यटकहरूको लागि बुझ्न गाह्रो परिक्षण जानकारी स्वचालित रूपमा थपिने छ जब चयन गरिएको उद्योगको परीक्षण जानकारी दर्ता पछि अद्यावधिक हुनेछ, र प्रयोगकर्तालाई सूचित गरिनेछ।",
    article3_sub3: "परीक्षा आवेदन एजेन्सी",
    article3_sub3_dec1: "जापानका विदेशी पर्यटकहरूलाई परीक्षाको लागि आवेदन दिन धेरै गाह्रो हुन्छ र तपाईले अनलाइन प्रक्रिया पूरा नगरीकन परीक्षा पनि लिन सक्नुहुन्न। जब तपाइँ दर्ता गर्नुहुन्छ, तपाइँले जानकारी पोष्ट गर्न सक्नुहुन्छ, पहिले नै आवेदन फारम छ र परीक्षा घोषणाको साथसाथै आवेदन दिन सक्नुहुन्छ।",
    article4: "परीक्षा उत्तीर्ण पछि समारोह परिचय",
    article4_sub1: "सफल आवेदकहरूलाई बधाई छ \n नगद फिर्ता (घरेलु वा अन्तर्राष्ट्रिय)",
    article4_sub1_dec1: "यदि तपाईं पहिले नै जापानमा बस्नुहुन्छ र AELU को प्रयोग गरेर पास गर्नुभयो र तपाईंको प्रयोगकर्ता स्क्रिनमा पास नम्बर र पास प्रमाणपत्र अपलोड गर्नुभयो भने, तपाईं उही दिनमा नगद फिर्ता लिन सक्नुहुनेछ। नगद फिर्ता योजना उत्पादन: अनलाइन उपहार प्रमाणपत्र (अमेजन उपहार प्रमाणपत्र ईमेल) प्रकार, गुगलप्ले, आईट्यून्स उपहार कार्ड) E००० येन मूल्य नगद आधिकारिक खाताबाट।",
    article4_sub2: "सन्दर्भ-एक मित्र अभियान",
    article4_sub2_dec1: "जापानमा आवेदकहरुलाई जापानमा आमन्त्रित गर्नुहोस् जो जापान वा विदेशमा रहेका एफबी समूहमा सामेल हुन, प्रयोगकर्ताले आफुको व्यवस्थापन नम्बर बताउनेछ र उक्त नम्बरसँग सम्बन्धित व्यक्तिलाई नगद फिर्ता लिनेछ, र परिचयकर्तालाई १००० अनलाइन उपहार प्रमाणपत्र दिनेछ। जोडिए पछि महिना। येन नगद फिर्ता।",
    article4_sub3: "भिसा पाइसकेपछि जागिर खोज्दै \n एआई स्वचालित मिलान हो (अनिश्चित)",
    article4_sub3_dec1: "AELU प्रयोग गरेर प्रमाणीकरण परीक्षा पास गरेपछि, प्रयोगकर्ता स्क्रिनमा पास नम्बर र पास प्रमाणपत्र अपलोड गर्नुहोस्, र तपाईं जापानका सबै कम्पनीहरूबाट स्वचालित प्रस्तावहरू प्राप्त गर्नुहुनेछ। अन्तर्वार्ताहरू पनि अनलाइन गरिन्छ, र तपाईं देश मा प्रवेश गर्न सक्षम हुनेछ, सार्न, र प्रारम्भिक अनौपचारिक अध्यायमा पनि अनलाइन जडान गरेर मानसिक शान्तिको साथ काम पाउनुहुनेछ!",
    article4_sub4: "निवास कार्डको नियमित जाँच \n नगद पछाडि (अनिश्चित),",
    article4_sub4_dec1: "यदि तपाइँ निवास खाता चेक अनुप्रयोग वन चेक ट्याबमा एर बिना महिनामा एक पटक आफ्नो निवास कार्ड जाँच गर्नुहुन्छ भने, तपाइँ एक वर्षमा १०,००० येन नगद फिर्ता पाउनुहुनेछ।",
    article5: "विशिष्ट समारोह परिचय,",
    article5_sub1: "तपाईंले समाधान गर्नुभएको समस्यामा फर्केर हेर्न सक्नुहुन्छ",
    article5_sub1_dec1: "तपाईं परीक्षा सामग्रीहरू सulate्कलन गर्न सक्नुहुनेछ जुन तपाईंले अनलाइन तालिम प्राप्त गर्नुभयो र आफ्ना उपकरणहरू प्रयोग गर्न प्रयोगकर्ताहरूको बानी बुझ्ने र समस्याहरू हटाउन सक्नुहुन्छ जुन तपाईं राम्रो हुनुहुन्न। तपाईं जति पटक चाहानुहुन्छ परीक्षणको लागि तयारी गर्न सक्नुहुने भएकोले सबै स्कोर ईतिहास र परिक्षण समय रेकर्ड गर्नुहोस्, र यथासक्दो वास्तविक परिक्षण दिनको नजीक गर्नुहोस्। थपमा, तपाई यस प्रश्नलाई राम्रोसँग बुझ्न सक्नुहुनेछ किनकि यो तपाईको आफ्नै भाषा र जापानी दुवैमा लेखिएको छ।",
    article5_sub2: "प्रविष्टिको समयमा तपाईंको पुनःसुरु स्थायी रूपमा बचत गर्नुहोस्",
    article5_sub2_dec1: "जब तपाइँ विशिष्ट कौशल भिसा परीक्षण लिनुहुन्छ र भिसाका लागि आवेदन गर्नुहुन्छ, जब तपाइँ जापानमा टेक्निकल इंटर्न प्रशिक्षार्थीको रूपमा प्रवेश गर्नुहुन्छ तपाईलाई पुनःसुरु आवश्यक पर्दछ। मूल रूपमा एक व्यवस्थापन संगठन (सहकारी) वा संस्था पठाउँदा भण्डार गरिएको, तपाईं यसलाई एक विशिष्ट सीसा भिसा प्राप्त गरे पछि तपाईं आफैंले भण्डार गर्न सक्नुहुन्छ।",
    article5_sub3: "तपाईंको देश र क्षेत्र को पंजीकरण समारोह,",
    article5_sub3_dec1: "तपाईंको आफ्नै देश र जापानको भाषा सँगै प्रयोग भएको हुनाले तपाईं यी प्रश्नहरू राम्रोसँग बुझ्न सक्नुहुन्छ र काउन्टरमेजर लिन सक्नुहुन्छ। मूल परीक्षामा, केवल जापानीहरू उपलब्ध छन्, त्यसैले तपाईं जापानीमा मात्र उपायहरू लिन सक्नुहुन्छ।",
    article5_sub4: "प्रमाणीकरण परीक्षा आवश्यकताहरू र जानकारीका रिमाइन्डरहरू",
    article5_sub4_dec1: "जब प्रत्येक परीक्षण समूह द्वारा इच्छित पेशाको लागि परीक्षण तालिका HP मा अपलोड हुन्छ, यो स्वचालित रूपमा रिमाइन्ड हुनेछ, प्रयोगकर्तालाई सूचित गरिनेछ, परीक्षण मिति प्रयोगकर्ता स्क्रिनमा सेट हुनेछ, र टाइमर स्वचालित रूपमा सञ्चालन हुनेछ।",
    article5_sub5: "स्क्रीनिंग प्रयोग गरी सिक्दै",
    article5_sub5_dec1: "तपाईं प्रयोगकर्ताको कमजोर पोइन्ट निकाल्न सक्नुहुन्छ र परीक्षाको लागि तयारी गर्न सक्नुहुन्छ।",
    article5_sub6: "अनलाइन शिक्षा परामर्श र स्मार्टफोन क्यामेरा प्रयोग साक्षात्कार।",
    article5_sub6_dec1: "Aer प्रयोग गरेर परीक्षाको तयारीको क्रममा, तपाईं अनलाइन कल र च्याटहरूको रूपमा प्रश्नको अर्थ र इरादा स्पष्ट गर्न सक्षम हुनुहुनेछ। यो जापानमा अभ्यस्त भएका वा यससँग परिचित व्यक्तिहरूको लागि आवश्यक नहुन सक्छ, तर आधारभूत कल परामर्श सेवा भनेको परीक्षा भन्दा पहिले कुनै पनि चिन्ताहरू जाँच्ने सबैभन्दा आश्वासनदायी तरीका हो!",
    article6: "शुल्क",
    article6_sub1: "AELU उपयोग शुल्क",
    article6_sub1_dec1: "तपाईं कुनै पनि प्रतिबन्ध बिना विशिष्ट कौशल भिसा परीक्षणको लागि अध्ययन गर्न सक्नुहुन्छ। तपाईं आफ्नो मातृभाषामा अनलाइन परामर्श लिन सक्नुहुन्छ। * तपाईं यसलाई सामान्य समयमा दोभाषेको रूपमा प्रयोग गर्न सक्नुहुनेछ। । n परीक्षण साइटमा घोषणा परीक्षणको दिनमा सम्भव छ। । n प्रविष्टिमा पुनःसुरु सदाका लागि सुरक्षित गर्न सकिन्छ। passing n परीक्षा उत्तीर्ण गरेपछि, तपाईको विशेष कौशल भिसा पास नम्बर दर्ता गर्नुहोस् तपाईको चाहेको काम पेश गर्नका लागि। (Undecided)",
    article6_sub2: "परीक्षा आवेदन एजेन्सी",
    article6_sub2_dec1: "तपाई कामको बखत आवेदन दिन सक्नुहुन्न, र तपाईले आवेदन नगरेसम्म तपाईले प्रमाणीकरण परीक्षा लिन सक्नुहुन्न, त्यसकारण हामी तुरून्त आवेदन गर्नेछौं जब प्रमाणीकरण परीक्षा जानकारी उपलब्ध हुन्छ ताकि तपाईले परीक्षाको मिति याद गर्नु हुँदैन।",
    article7: "Cashback अभियान प्रगतिमा छ!",
    article7_dec1: "परीक्षा उत्तीर्ण गर्नेहरूबाट, यस सेवाका लागि भिसा नम्बर दर्ता गर्नेहरूले 5,000,००० en n येनको क्यासब्याक प्राप्त गर्नेछन्! अभियानमा कसरी भाग लिने भनेर यहाँ क्लिक गर्नुहोस्।",
    article8: "अब AELU का साथ दर्ता गर्न दिन्छ!",
    dashboard: "ड्यासबोर्ड",
    member_info: "प्रोफाइल जानकारी को पंजीकरण",
    first_name: "नाम",
    midle_name: "बीचको नाम",
    family_name: "थर",
    half_width_Roman: "रोमाजी आधा चौड़ाई",
    password: "पासवर्ड",
    password_confirm: "पासवर्ड पुष्टिकरण",
    mail_adress: "मेल ठेगाना",
    lineId: "लाइन आईडी",
    country_id: "देश कोड",
    phone: "फोन नम्बर",
    issuing_country: "देश / आईडी कार्ड जारीको क्षेत्र छान्नुहोस्",
    IDtype: "आईडी प्रकार चयन",
    residence_card: "निवास कार्ड वा आईडी कार्ड",
    passport: "राहदानी",
    regist: "पञ्जीकरण",
    is_required: "अनिवार्य छ",
    sign_up: "साइन अप",
    residence_front: "सतह अपलोड",
    residence_back: "पछाडि अपलोड गर्नुहोस्",
    passport_upload: "तपाईंको राहदानी अपलोड गर्नुहोस्",
    error_file: "कृपया छवि अपलोड गर्नुहोस्",
    post_resume: "पुनःसुरु बुझाउनुहोस्",
    resume_upload: "पुनःसुरु अपलोड गर्नुहोस्",
    click_upload: "अपलोड गर्न क्लिक गर्नुहोस्",
    image_drop: "वा तस्विर फाइल ड्र्याग र ड्रप गर्नुहोस्",
    select_language: "मातृभाषा को छनोट",
    vietnamese: "भियतनामी",
    chinese: "चीनियाँ",
    english: "अंग्रेजी",
    khmer: "खमेर",
    indonesian: "इन्डोनेसियाली",
    tagalog: "तागालोग",
    burmese: "बर्मी",
    hindu: "हिन्दू",
    lao: "लाओ",
    mongolian: "मंगोलियाई",
    bengali: "बंगाली",
    sinhala: "सिंहला",
    banglodesh: "बंगलादेशी",
    malay: "मलाय",
    nepali: "नेपाली",
    thai: "थाई",
    japanese: "जापानी",
    error_lang: "कृपया तपाइँको मातृभाषा चयन गर्नुहोस्।",
    select_ouccupation: "कार्य प्रकार चयन",
    select_max_three: "तपाई तीनलाई चयन गर्न सक्नुहुन्छ।",
    industry_id_1: "दीर्घकालीन देखभाल उद्योग",
    industry_id_2: "भवन सफाई व्यवसाय",
    industry_id_3: "कच्चा माल उद्योग",
    industry_id_4: "औद्योगिक मेसिनरी उत्पादन उद्योग",
    industry_id_5: "इलेक्ट्रिकल र इलेक्ट्रोनिक जानकारी सम्बन्धित उद्योगहरू",
    industry_id_6: "निर्माण उद्योग",
    industry_id_7: "शिपबिल्डिंग / समुद्री उद्योग",
    industry_id_8: "कार मर्मत उद्योग",
    industry_id_9: "उड्डयन उद्योग",
    industry_id_10: "आवास व्यवसाय",
    industry_id_11: "कृषि",
    industry_id_12: "माछा पालन",
    industry_id_13: "खाद्य र पेय पदार्थ निर्माण",
    industry_id_14: "भोजनालय व्यवसाय",
    industry: "उद्योग",
    error_occupation: "कृपया एक वा बढी काम प्रकारहरू चयन गर्नुहोस्।",
    do: "गर्नु पर्ने",
    news_tpic: "समाचार",
    days_until_exam: "परीक्षा सम्म बाँकी दिनहरू",
    estimated_pass_rate: "अनुमानित पास दर",
    average_score_taken: "लिइएको परिक्षणको औसत स्कोर",
    exam: "परीक्षा छ",
    let_aim: "को लागि लक्ष्य दिन्छ",
    score: "पोइन्ट",
    solve_problem: "प्रश्न समाधान गर्नुहोस्",
    recommend_problem: "AELUs सिफारिश गरिएको प्रश्न",
    solved_problem: "विगतमा प्रश्न समाधान भयो",
    looking_solved: "विगतका प्रश्नहरू जाँच गर्नुहोस्",
    application_agency: "परीक्षा आवेदन एजेन्सी सेवा",
    billing: "बिलि",
    more_look: "थप जाँच गर्नुहोस्",
    more_look2: "थप जाँच गर्नुहोस्",
    facebook: "फेसबुक",
    google: "गूगल",
    until_not_account: "यदि तपाईंसँग अझै खाता छैन",
    or: "वा",
    other_way: "अन्य तरिकाहरूमा",
    not_have_account: "यदि तपाईंसँग खाता छैन भने",
    have_account: "यदि तपाइँसँग एक खाता छ",
    forgot_password: "यदि तपाईंले आफ्नो पासवर्ड बिर्सनुभयो भने",
    this: "यहाँ",
    at_login: "संग लग ईन गर्नुहोस्",
    pass_condition: "Or वा अधिक एकल बाइट अल्फान्यूमेरिक क्यापिटल अक्षरहरू",
    at_sign_up: "यसका साथ नयाँ दर्ता",
    agreement1: "निम्नसँग सहमत भई जारी राख्न छनौट गरेर, AELU",
    terms: "सेवाका सर्तहरु",
    agreement2: "म तपाईँसँग सहमत छु।",
    agree: "सहमत हुनुहोस् र जारी राख्नुहोस्",
    account_confirm: "कन्फर्मेसन कोड",
    confirm: "पुष्टिकरण",
    not_confirm: "पुष्टिकरण कोड पुष्टि गरिएको छैन।",
    move_confiirm: "पुष्टिकरण कोड इनपुट स्क्रिनमा सारिन्छ",
    top: "माथि",
    news_list: "समाचार सूची",
    problim_list: "प्रश्न सूची",
    learning_consul: "परामर्श सिक्दै",
    agency: "परीक्षा जानकारी",
    of_trend: "परीक्षणको चलनको बारेमा",
    start_test: "परीक्षण सुरू गर्नुहोस्",
    study_mode: "अध्ययन मोड",
    order_question: "प्रश्न",
    of_question: "प्रश्नमा",
    question_current: "प्रश्न सही उत्तर",
    to_mypage: "मेरो पृष्ठमा",
    correct_answer: "सही उत्तर!",
    correct_answer_normal: "सही उत्तर",
    no_correct_answer: "गलत उत्तर",
    next: "अर्को प्रश्न गर्न",
    finish_all: "सबै प्रश्नहरूको उत्तर!",
    your_score: "तपाईंको स्कोर छ",
    is: "हो!",
    result_description: "तपाईं अन्य प्रश्नहरू सुल्झाउन सक्नुहुन्छ प्रश्नहरूको सूची हेर्नुहोस्बाट। तपाईं प्रश्न सूची पृष्ठबाट विगतमा सुल्झाउनुभएका प्रश्नहरूमा फर्केर पनि हेर्न सक्नुहुन्छ।",
    back_quiz_list: "प्रश्नहरूको सूची जाँच गर्नुहोस्",
    retry: "यो प्रश्न फेरि समाधान गर्नुहोस्",
    no_description: "त्यहाँ कुनै स्पष्टीकरण छैन",
    show_ans: "उत्तर जाँच गर्नुहोस्",
    of_solved_problem: "विगतमा प्रश्न समाधान भयो",
    of_solved_problem_list: "विगतमा समाधान गरिएका प्रश्नहरूको सूची",
    solved_description: "तपाईं फेरि लामो अवधि को देखभाल उद्योग को विशिष्ट कौशल भिसा परीक्षण को लागी सिकाई जाँच गर्न सक्नुहुन्छ।",
    before_result: "अघिल्लो परिणामहरू",
    looking_back: "फेरी जाँच गर्नुहोस्",
    back_solved_problem_list: "विगतमा समाधान भएका प्रश्नहरूको सूची जाँच गर्नुहोस्",
    again_retry: "यस प्रश्नलाई फेरि फर्काउँदै",
    done_member_regist: "सदस्यको रूपमा दर्ता गर्नुभएकोमा धन्यवाद!",
    done_member_regist_description: "प्रत्येक सेवा उपलब्ध हुनेछ तपाईंले सेवा प्रयोग शुल्क तिरे पछि। । n कृपया तपाईंको भुक्तान जानकारी रेजिस्टर गर्नुहोस्।",
    choose_payment: "एक भुक्तानी विधि छनौट गर्नुहोस्",
    service_content: "सेवा सामग्री",
    test_info_service: "परीक्षा जानकारी सेवा",
    usage_fee: "उपयोग शुल्क",
    test_fee: "Y०० येन + कर",
    application_fee: "२०००० येन + कर",
    method_payment: "भुक्तानी विधि",
    LINE_pay: "लाइन भुक्तानी",
    line_pay_description: "* कृपया QR कोड छवि बचत गर्नुहोस् र लाइन पे सेवा भित्र भुक्तान गर्नुहोस्। जब लाइन पे संग भुक्तानी हुन्छ व्यवस्थापनको लागि यकिन हुन यसले समय लिन सक्दछ।",
    save_qr: "QR कोड बचत गर्नुहोस्",
    next_stage: "अर्को",
    credit_card: "क्रेडिट कार्ड",
    copmplete_payment: "भुक्तानी पूरा भयो।",
    copmplete_payment_descript: "अब जब भुक्तानी सकियो, तपाईं अनलाइन परीक्षा अध्ययन समारोह, परीक्षा जानकारी, र परीक्षा आवेदन एजेन्सी सेवा प्रयोग गर्न सक्नुहुनेछ।",
    start_sevice: "सेवा प्रयोग गर्न सुरु गर्नुहोस्",
    to_payment: "भुक्तानी स्क्रिनमा",
    of_news_list: "समाचार सूची",
    done_payment: "भुक्तानी पूरा भएको छ।",
    tv_consult: "भिडियोफोन परामर्श",
    tell_consult: "टेलिफोन परामर्श",
    learning_consul_descript01: "परीक्षा आवेदन",
    learning_consul_descript02: "हामी तपाईंको तर्फबाट कार्य गर्नेछौं",
    money_unit: "JPY",
    learning_consul_unit: "एक पटक",
    fault_payment1: "भुक्तानी असफल भयो।",
    fault_payment2: "फेरि प्रयास गर्नुहोस।",
    no_examination: "अझै होईन",
    no_exam: "अहिले सम्म कुनै परीक्षा छैन",
    undecided: "अनिर्णित",
    retry_login: "कृपया पुन: लग ईन गर्नुहोस्",
    no_problem: "त्यहाँ कुनै qestion हल गरिएको छैन",
    do_problem: "प्रश्न समाधान गर्नुहोस्",
    qa_title: "बारम्बार सोधिने प्रश्नहरू",
    search_category: "श्रेणी द्वारा संकुचित",
    search_freeward: "नि: शुल्क शब्द द्वारा खोजी गर्नुहोस्",
    test_result: "अभ्यास परीक्षण परिणामहरू",
    to_top: "शीर्षमा",
    missPassword: "गलत पासवर्ड वा ईमेल ठेगाना",
    sample_problem: "अनलाइन परीक्षाको लागि अध्ययनको अनुभव",
    exercises: "व्यायाम",
    let_exercises: "केवल एक वास्तविक समस्या समाधान गरौं!",
    to_qa: "अधिक प्रश्नोत्तर जाँच गर्नुहोस्",
    read_more: "थप जाँच गर्नुहोस्",
    account_setting: "खाता सेटिंग",
    profile_setting: "प्रोफाइल सेटिंग्स",
    notification_setting: "सूचना सेटिंग्स",
    logout: "बाहिर निस्कनु",
    changeEmail: "ईमेल ठेगाना परिवर्तन गर्नुहोस्",
    changePassword: "पासवर्ड परिवर्तन गर्नुहोस्",
    change: "परिवर्तन",
    save: "बचत गर्नुहोस्",
    change_success: "परिवर्तन सम्पन्न भयो",
    now_password: "वर्तमान पासवर्ड",
    new_password: "नया पासवर्ड",
    check_new_password: "नयाँ पासवर्ड (पुष्टिकरण)",
    do_logout: "लग आउट",
    done_learning_consul_payment: "भुक्तानी सकियो।",
    past_exam: "विगतका प्रश्नहरू",
    update_info: "पछिल्लो जानकारी अपडेट गर्दै",
    official_sns: "आधिकारिक SNS",
    privacy_policy: "गोपनीयता नीति",
    terms_service: "सेवाका सर्तहरु",
    transaction_law: "निर्दिष्ट वाणिज्यिक लेनदेन कानून मा आधारित संकेत",
    selectCountry: "कृपया एक देश छान्नुहोस्",
    goInquiry: "अनुसन्धान गर्न अगाडि बढ्नुहोस्",
    lineInquiry: "लाइन मार्फत हामीलाई सम्पर्क गर्नुहोस्",
    regist_accept_certificate: "विशिष्ट कौशल भिसा अधिग्रहण पास प्रमाणपत्रको पंजीकरण",
    accept_certificate_description: "तपाइँ तपाइँको पास प्रमाणपत्र र नम्बर दर्ता गर्न सक्नुहुन्छ",
    accept_certificate: "स्वीकृति को प्रमाणपत्र",
    accept_number: "पास नम्बर",
    immigration_resume: "प्रविष्टिको समयमा दर्ता पुनः सुरु गर्नुहोस्",
    resendCode: "प्रमाणिकरण कोड पुन: पठाउनुहोस्",
    line_at_register: "LINE @ मार्फत सेवा सोधपुछ",
    study: "अध्ययन गर्नुहोस् र फेरि जाँच गर्नुहोस्",
    study_text: "शिक्षण पाठ डाउनलोड गर्नुहोस्",
    do_resume_update: "कृपया तपाईंको पुनःसुरु अपलोड गर्नुहोस्",
    done_resume_update: "तपाईंको पुनःसुरु दर्ता गर्नुभएकोमा धन्यवाद!",
    regist_resume_enter: "प्रविष्टिको समयमा पुनःसुरुको पंजीकरण",
    about_company: "अपरेटिंग कम्पनीको बारेमा",
    add_exam_info_detail: "परीक्षा जानकारी थपिएको छ। विवरण र अनुप्रयोगको लागि यहाँ क्लिक गर्नुहोस्",
    regist_result_get_money: "तपाईंको परीक्षा परिणामहरू दर्ता गर्नुहोस् र तपाईंको पैसा पाउनुहोस्",
    detail: "विवरण",
    about_withdrawal_subsc: "सदस्यता फिर्ता र रद्दको बारेमा",
    apply_withdrawal: "सदस्यता रद्दको लागि अनुप्रयोग",
    apply_subsc: "सदस्यता बाट सदस्यता रद्दको लागि आवेदन",
    about_withdrawal: "फिर्ता प्रक्रिया",
    about_subsc: "सदस्यताबाट सदस्यता रद्द गर्नुहोस्",
    exam_info: "परीक्षा जानकारी",
    date: "मिति र समय",
    day: "दिन",
    place: "स्थान",
    result_publication: "परिणाम प्रकाशन",
    result_publication_place: "परिणाम घोषणा गर्न ठाउँ",
    result_this_page: "यस पृष्ठमा घोषणा गरिनेछ",
    exam_way: "परीक्षा ढाँचा",
    exam_way2: "परीक्षा प्रश्न ढाँचा",
    include_exam_fee: "परीक्षण शुल्क सहित",
    exam_application_desc: "परीक्षा आवेदन फारम बुझाउने। office n परीक्षा कार्यालयसँग अन्तर्क्रिया \n दिन द्वारा के तयारी गर्ने सम्बन्धमा (लाइन ०) \n परीक्षाको सम्बन्धमा कुनै प्रश्नहरूको लागि परामर्श",
    self_application: "आफैंले आवेदन दिनुहोस्",
    application_method: "कसरी आवेदन गर्ने",
    under_this_url: "कृपया निम्न URL बाट आवेदन प्रक्रिया पूरा गर्नुहोस्।",
    do_appliction: "परीक्षाको लागि आवेदन दिनुहोस्",
    study_with_aeru: "उत्तीर्ण दर बढाउन शीर्ष पृष्ठबाट परीक्षा अध्ययन प्रकार्य प्रयोग गर्नुहोस्।",
    line_at_consul: "लाइन @ शिक्षा परामर्श सेवा",
    instagram: "इन्स्टाग्राम",
    do_signup: "तपाई प्रमाणिकरण हुनुभयो। । n कृपया पुन: लग ईन गर्नुहोस्।",
    gender: "लि .्ग",
    man: "नर",
    woman: "महिला",
    input_problem_title: "समस्याको शीर्षक समावेश गर्दछ ...",
    still_no_problem: "समस्या छैन",
    enter_in_problem_trend: "अहिले सम्मको परीक्षाको प्रवृत्तिहरू र उत्तर ढाँचा (चयन प्रकार) जस्ता परीक्षाको संक्षिप्त विवरण समावेश गर्दछ।",
    correct: "सही उत्तर",
    explanation: "स्पष्टीकरण",
    problem: "प्रश्न",
    do_nursing_not_published: "परीक्षा दीर्घकालीन देखभाल उद्योगमा सञ्चालन भइरहेको छ तर विगतका प्रश्नहरू प्रकाशित भएका छैनन्।",
    practical_exam_of_year: "वर्ष व्यावहारिक परीक्षण",
    judgment_test_of_year: "२०१ Jud जजमेन्ट परीक्षा",
    judgment_test_answer_of_year: "२०१ Jud जजमेन्ट परीक्षा उत्तर",
    not_yet_test_material: "कच्चा माल उद्योगमा अझै परीक्षा छैन",
    not_yet_test_machinery: "औद्योगिक मेशिनरी उत्पादन क्षेत्रमा अझै परीक्षा छैन",
    not_yet_test_electronic: "विद्युतीय र इलेक्ट्रोनिक जानकारी सम्बन्धित उद्योगमा अहिले सम्म परीक्षा छैन",
    not_yet_test_construction: "निर्माण उद्योगमा अहिलेसम्म परीक्षा छैन",
    not_yet_test_shipbuilding: "अहिलेसम्म जहाज निर्माण र समुद्री उद्योगमा परीक्षा छैन",
    do_automobile_not_published: "परीक्षा अटोमोबाईल मर्मतसम्भारको क्षेत्रमा सञ्चालन भइरहेको छ तर विगतका प्रश्नहरू प्रकाशित भएका छैनन्।",
    do_aviation_not_published: "परीक्षा उड्डयन उद्योगमा सञ्चालन भइरहेको छ तर विगतका प्रश्नहरू प्रकाशित भएका छैनन्।",
    do_agricultural_not_published: "कृषि क्षेत्रमा परीक्षाहरू सञ्चालन भइरहेको छ तर विगतका प्रश्नहरू प्रकाशित भएका छैनन्।",
    do_fishery_not_published: "मत्स्यपालन क्षेत्रमा परीक्षाहरू सञ्चालन भइरहेको छ तर विगतका प्रश्नहरू प्रकाशित भएका छैनन्।",
    do_food_not_published: "खाद्य र पेय पदार्थ उत्पादन उद्योगमा परीक्षाहरू सञ्चालन भइरहेको छ तर विगतका प्रश्नहरू प्रकाशित भएका छैनन्।",
    do_restaurant_not_published: "खाद्य सेवा उद्योगमा परीक्षाहरू सञ्चालन भइरहेको छ तर विगतका प्रश्नहरू प्रकाशित भएका छैनन्।",
    schedule_undecided: "(* अनुसूची अनिर्णित छ)",
    year: "बर्ष",
    month: "चन्द्रमा",
    texts_learning: "प्रत्येक उद्योग सिक्न को लागी पाठ्य पुस्तकहरु",
    texts_learning_test: "विशिष्ट कौशल मूल्यांकन परीक्षा शिक्षा पाठ (जापानीज)",
    skill_test_sample: "कौशल मूल्यांकन परीक्षा नमूना",
    japanese_test_sample: "जापानी मूल्यांकन परीक्षा नमूना",
    not_building_texts: "भवन सफाई उद्योगको लागि अझै कुनै पाठ्य पुस्तक छैन।",
    not_material_texts: "कच्चा माल उद्योगको लागि अझै कुनै पाठ्य पुस्तक छैन।",
    not_machinery_texts: "औद्योगिक मेसिनरी म्यान्युफ्याक्चरिंगको क्षेत्रमा अझै कुनै पाठ्यपुस्तक छैन।",
    not_electronic_texts: "विद्युतीय र इलेक्ट्रोनिक जानकारी सम्बन्धित उद्योगहरूको लागि कुनै पाठ्य पुस्तक छैन।",
    not_shipbuilding_texts: "जहाज निर्माण / समुद्री उद्योगको लागि अझै कुनै पाठ्य पुस्तक छैन।",
    not_automobile_texts: "अटोमोबाइल मर्मत उद्योगको लागि अझै कुनै पाठ्य पुस्तक छैन।",
    not_accommodation_texts: "आवास उद्योगको लागि अझै कुनै पाठ्य पुस्तक छैन।",
    not_food_texts: "खाद्य र पेय पदार्थ उत्पादन उद्योगको लागि अहिलेसम्म कुनै पाठ्य पुस्तक छैन।",
    not_restaurant_texts: "खाना सेवा कौशल मापन परीक्षा शिक्षण पाठ्यपुस्तक",
    each_depertment_texts: "प्रत्येक विभागमा परीक्षा सिक्नको लागि पाठ्य पुस्तकहरु",
    skill_test_basic: "कौशल मूल्यांकन परीक्षा शिक्षा पाठ (आधारभूत टेक्नोलोजी)",
    skill_test_safety: "कौशल मूल्यांकन परीक्षा शिक्षा पाठ (कार्य सुरक्षा / गुणवत्ता)",
    skill_test_aircraft: "कौशल मूल्यांकन परीक्षा शिक्षा पाठ (विमान अवलोकन)",
    texts_livestock: "[पशुधन खेती सिक्नको लागि पाठ्यपुस्तक] जापानी संस्करण",
    texts_cultivated: "[खेती कृषि सिक्नको लागि पाठ] जापानी संस्करण",
    skill_test_fishery: "माछा पालन कौशल मापन परीक्षा (मत्स्य पालन)",
    skill_test_general_fishery: "माछा पालन कौशल मापन परीक्षा (सामान्य मत्स्य पालन)",
    skill_test_safety_fishery: "माछा पालन कौशल मापन परीक्षा (मत्स्य सुरक्षा)",
    skill_test_specialty_fishery: "माछा पालन कौशल मापन परीक्षा (माछा पालन विशेष नेट सम्बन्धित)",
    skill_test_related_fishery: "मत्स्यपालन कौशल मापन परीक्षा (माछा पालन विशेषता फिशिंग सम्बन्धित)",
    skill_test_aquaculture: "माछा पालन कौशल मापन परीक्षा (एक्वाकल्चर)",
    skill_test_general_aquaculture: "मत्स्य कौशल मापन परीक्षा (एक्वाकल्चर सामान्य / सुरक्षा)",
    skill_test_feeding_aquaculture: "माछा पालन कौशल मापन परीक्षा (फीडिंग र एक्वाकल्चर)",
    skill_test_non_feeding_aquaculture: "मत्स्य कौशल मापन परीक्षा (अनावश्यक एक्वाकल्चरसँग सम्बन्धित)",
    registration_skill_visa: "विशिष्ट कौशल भिसाको स्वीकृति प्रमाणपत्रको पंजीकरण",
    please_register_pdf_number: "कृपया एक विशिष्ट सीप भिसा र पास प्रमाणपत्रमा पास नम्बर प्राप्त गर्न पास प्रमाणपत्रको फोटो वा PDF दर्ता गर्नुहोस्।",
    regist_and_get_cash_bag: "यदि तपाईंले अहिले दर्ता गर्नुभयो भने, तपाईं नगदी ब्यागको साथ 5000००० येन प्राप्त गर्न सक्नुहुनेछ।",
    thank_you_regist_visa_pass: "विशेष कौशल भिसा पारित गरेको प्रमाणपत्र दर्ता गर्नुभएकोमा धन्यवाद!",
    exam_info_detail: "परीक्षा कार्यान्वयनको रूपरेखा",
    em_exam_detail_language: "स्थानीय भाषामा गर्नु पर्छ",
    em_exam_detail_method: "विभाग परीक्षा, व्यावहारिक परीक्षा",
    em_exam_detail_way: "कम्प्युटर-आधारित परीक्षण (CBT) कागज परीक्षण विधि वा उत्पादन जस्तो कार्य परीक्षण विधि",
    em_exam_detail_section: "१ examination परीक्षा कोटीहरू (कास्टि,, फोर्जिंग, डाई कास्टिंग, मशीनिंग, मेटल मुद्रांकन, इस्त्रीको काम, कारखाना शीट मेटल, प्लेटिंग, एल्युमिनियम एनोडाइजेसन, फिनिशिंग, मेकेनिकल निरीक्षण, मेशिन मर्मत, इलेक्ट्रोनिक उपकरण असेंब्ली, इलेक्ट्रिकल उपकरण असेंब्ली, प्रिन्ट गरिएको तार बोर्ड बोर्ड निर्माण, प्लास्टिक मोल्डिंग) , चित्र, वेल्डिंग, औद्योगिक प्याकेजि))",
    em_exam_detail_notify: "परीक्षा पछि, ईमेल द्वारा परिणाम सूचना पठाउनुहोस्।",
    em_exam_detail_border: "विभाग परीक्षण:% 65% वा अधिक \n व्यावहारिक परीक्षण: points० पोइन्ट वा अधिक",
    ss_exam_detail_language: "जापानी",
    ss_exam_detail_method: "प्रवीणता परीक्षण एक व्यावहारिक परीक्षण र एक विभाग परीक्षण द्वारा आयोजित गरीन्छ। business n व्यावहारिक परीक्षाहरू प्रत्येक व्यवसाय कोटीको लागि आयोजित गरिन्छ। । n विभाग परीक्षण कागज परीक्षण विधि द्वारा प्रत्येक व्यवसाय कोटि को लागी आयोजित गरीन्छ।",
    ss_exam_detail_way: "कागज परीक्षण विधि, आदि।",
    ss_exam_detail_section: "विभाग / अभ्यास / कौशल: वेल्डिंग, चित्रकला, इस्त्री वर्क, परिष्करण, मशीनिंग, विद्युत उपकरण असेंब्ली",
    ss_exam_detail_notify: "-",
    ss_exam_detail_border: "विभाग परीक्षण: %०% वा अधिक \n व्यावहारिक परीक्षण: व्यावहारिक नतीजामा आधारित फैसला",
    c_exam_detail_language: "जापानी",
    c_exam_detail_method: "प्रवीणता परीक्षण एक व्यावहारिक परीक्षण र एक विभाग परीक्षण द्वारा आयोजित गरीन्छ।",
    c_exam_detail_way: "कम्प्युटर-आधारित परीक्षण (CBT), व्यावहारिक परीक्षण एक पञ्जीकृत निगम द्वारा निर्दिष्ट एक विधि हो",
    c_exam_detail_section: "-",
    c_exam_detail_notify: "वेबसाइटमा प्रकाशित",
    c_exam_detail_border: "विभाग परीक्षण:% 65% वा अधिक \n व्यावहारिक परीक्षण: व्यावहारिक नतीजाहरूको आधारमा फैसला",
    cm_exam_detail_language: "जापानी",
    cm_exam_detail_method: "प्रवीणता परीक्षण एक व्यावहारिक परीक्षण र एक विभाग परीक्षण द्वारा आयोजित गरीन्छ।",
    cm_exam_detail_way: "कम्प्यूटर-आधारित परीक्षण (CBT) द्वारा शैक्षिक र व्यावहारिक परीक्षा प्रदर्शन गर्नुहोस्",
    cm_exam_detail_section: "विषय परीक्षाको विषय \n संरचना, प्रकार्य र ह्यान्डल गर्ने विधिको बारेमा प्राथमिक ज्ञान inspection n निरीक्षण, मर्मत र समायोजनको बारेमा प्राथमिक ज्ञान \n संरचना, समारोह र परीक्षण गर्ने मेशीनको विधि, मापन उपकरण र रखरखावको लागि उपकरणको बारेमा प्राथमिक ज्ञान \n प्राथमिक ज्ञान सामग्री र ईन्धन र फ्याटहरूको गुणधर्म र प्रयोगको बारेमा \n व्यावहारिक परीक्षा विषयहरू \nA साधारण आधारभूत काम \nB पृथक, विधानसभा, सरल निरीक्षण र समायोजन C nC सजिलो मर्मत \nD रखरखाव परीक्षण मेशिनहरूको सहज ह्यान्डलिंग, मापन उपकरण र उपकरणहरू।",
    cm_exam_detail_notify: "",
    cm_exam_detail_border: "विभाग परीक्षण:% 65% वा अधिक व्यावहारिक परीक्षण: कुल स्कोर %०% वा अधिक",
    a_exam_detail_language: "स्थानीय भाषा र जापानी",
    a_exam_detail_way: "कम्प्युटर-आधारित परीक्षण (CBT), कागज परीक्षण विधि",
    a_exam_detail_section: "विभागले सामान्य, सुरक्षा र स्वास्थ्य, खेती गरिएको बालीको प्रजाति / विशेषता, खेती वातावरण (सुविधा / उपकरण / सामग्री / मेशिनरी), खेती विधि / व्यवस्थापन, किरा / झार नियन्त्रण, कटनी / समायोजन / भण्डारण / ढुवानी - कृषि माटो अवलोकन, मल / कीटनाशक हेन्डलिंग, बिउलाई ह्यान्डल गर्ने, वातावरणीय व्यवस्थापन, सामग्री / उपकरण / मेशिनको संभाल, खेती, सुरक्षा र स्वास्थ्य सम्बन्धी कार्य ③ जापानी भाषामा निर्देशित कृषि कार्यको विषयवस्तु सुनेर।",
    a_exam_detail_notify: "वेबसाइटमा प्रकाशित",
    a_exam_detail_border: "कुल स्कोर कृषि नेशनल चेम्बर द्वारा निर्धारित निर्णय संदर्भ विन्दु भन्दा बढी छ।",
    avi_exam_detail_method: "प्रवीणता परीक्षा व्यावहारिक परीक्षा र एक विभाग परीक्षा द्वारा आयोजित गरिन्छ।",
    avi_exam_detail_section: "प्रश्नहरू जापान एविएशन टेक्नोलोजी एसोसिएशनको वेबसाइटमा पोष्ट गरिएको पाठबाट दिइनेछ। व्यावहारिक कौशल निष्कर्ष, विद्युत मापन",
    avi_exam_detail_notify: "",
    avi_exam_detail_border: "विभाग परीक्षण:% 65% वा अधिक व्यावहारिक परीक्षण: कुल स्कोर% 65% वा अधिक",
    f_exam_detail_language: "जापानी",
    f_exam_detail_method: "प्रवीणता परीक्षण एक व्यावहारिक परीक्षण र एक विभाग परीक्षण द्वारा आयोजित गरीन्छ।",
    f_exam_detail_way: "कम्प्यूटर-आधारित परीक्षण (CBT) द्वारा शैक्षिक र व्यावहारिक परीक्षा प्रदर्शन गर्नुहोस्",
    f_exam_detail_section: "परीक्षण विषयले यो निश्चित गर्दछ कि माछा पालन क्षेत्र (माछा पालन) वा मत्स्यपालन क्षेत्र (एक्वाकल्चर) मा कामको एक निश्चित डिग्री पर्यवेक्षकको निर्देशनहरू बुझेर सही तरिकाले गर्न सकिन्छ वा आफ्नै विवेकमा गर्न सकिन्छ, र केवल विशिष्ट छ । यो उपस्थिति वा ज्ञानको अनुपस्थितिको मूल्यांकन होईन, तर माछा मार्ने क्षेत्र (माछा पालन) वा मत्स्यपालन क्षेत्र (एक्वाकल्चर) मा कार्य गर्न आवश्यक पर्ने सही निर्णय र कार्य ज्ञानको उपस्थिति वा अनुपस्थितिको मूल्यांकन गर्न पनि सम्भव छ।",
    f_exam_detail_notify: "वेबसाइटमा प्रकाशित",
    f_exam_detail_border: "लिखित परीक्षा को कुल स्कोर र व्यावहारिक परीक्षण प्रवीणता परीक्षा कार्यान्वयन एजेन्सी द्वारा निर्धारित निर्णय मानक स्कोर भन्दा बढी स्वीकार्य छन्।",
    no_exam_info: "कुनै परीक्षण सारांश जानकारी जारी गरिएको छैन",
    language: "कार्यान्वयन भाषा",
    method: "कार्यान्वयन विधि",
    way: "कार्यान्वयन विधि",
    section: "Exzmission कोटी",
    notify: "परीक्षा परिणामहरूको सूचना",
    border: "परीक्षा परिणाम मापदण्ड",
    go_line_at: "लाईन @",
    thank_you_and_deactivate: "प्रयोग गर्नुभएकोमा धन्यबाद। सेवाबाट फिर्ता लिने प्रक्रियाका लागि, कृपया तल लाइन @ विन्डोबाट फिर्ताका लागि प्रक्रिया प्रविष्ट गर्नुहोस्। नियमित भुक्तानी रद्द गर्नका लागि कृपया तलको लाइन @ विन्डोबाट नियमित भुक्तानी रद्द गर्नुहोस्। हामीले प्रक्रिया पाउने बित्तिकै हामीले कन्फर्मेसन पाउनेछौं।",
    thank_you_and_subscribe: "प्रयोग गर्नुभएकोमा धन्यबाद। नियमित भुक्तानी रद्द गर्नका लागि कृपया तलको लाइन @ विन्डोबाट नियमित भुक्तानी रद्द गर्नुहोस्। । n हामी यथाशीघ्र हामीले कन्फर्मेसन प्राप्त गर्नेछौं।",
    ten_thousand_yen: "दस हजार येन",
    yen_per_month: "JPY / महिना",
    how_to_use_this_service: "प्रयोगको प्रवाह",
    selecting_a_browser: "ब्राउजर चयन",
    selecting_a_browser_dec: "ब्राउजरको साथ https://aelu.co.jp पहुँच गर्नुहोस् (गुगल क्रोम, सफारी, किनारा, आदि।) * कुनै अनुप्रयोग छैन।",
    provisional_registration: "अस्थायी रेजिष्ट्रेसन",
    provisional_registration_dec: "तपाईंको फेसबुक वा गुगल आईडीको साथ लग इन गर्नुहोस् वा तपाईंको ईमेल ठेगानाको साथ दर्ता गर्नुहोस्। इच्छित भाषा र इच्छित पेशा चयन गरेपछि, तपाईं अनलाइन प्रमाणन परीक्षा मक सामग्री ब्राउज गर्न सक्नुहुन्छ।",
    full_registration: "मुख्य दर्ता",
    full_registration_dec: "अनलाइन प्रमाणीकरण परीक्षा सामग्री पृष्ठमा मुख्य दर्ता क्लिक गर्नुहोस्, आवश्यक जानकारी भर्नुहोस्, र १ industry उद्योग प्रमाणीकरण परीक्षा अभ्यास प्रश्न सहित सबै सेवाहरू प्रयोग गर्नुहोस्।",
    name_validate_message: "कृपया उही हिज्जेको साथ जानकारी प्रविष्ट गर्नुहोस् यो तपाईंको पासपोर्टमा देखिन्छ।",
    live_at_area: "क्षेत्र जहाँ तपाईं हाल बस्नुहुन्छ",
    agency_application: "परीक्षा आवेदन को लागी अभिनय",
    mypage: "मेरो पृष्ठ",
    myanmar: "बर्मी",
    exam_list: "परीक्षा तालिका सूची",
    no: "होईन",
    times: "टाइम्स",
    application_start: "अनुप्रयोग सुरू गर्नुहोस्",
    application_end: "आवेदन अन्तिम म्याद",
    enforcement: "कार्यान्वयन",
    applicated: "लागू गरिएको",
    reception_time: "स्वागत समय",
    announthment_d: "स्वीकृति को घोषणा को मिति",
    reception_period: "अनुप्रयोग अवधि",
    detail_link: "विवरण जाँच गर्नुहोस्",
    exam_country: "होस्ट देश",
    line: "लाइन",
    vietnum: "भियतनाम",
    laos: "लाओस",
    malaysia: "मलेशिया",
    bangladesh: "बंगलादेश",
    indo: "भारत",
    nepal: "नेपाल",
    mongol: "मंगोलिया",
    indonesia: "इन्डोनेसिया",
    th: "थाईल्यान्ड",
    philipine: "फिलिपिन्स",
    my: "म्यानमार",
    uzbekistan: "उज्बेकिस्तान",
    pakistan: "पाकिस्तान",
    japan: "जापान",
    news_title: "विशिष्ट कौशल भिसाको बारेमा समाचार",
    missNowPassword: "हालको पासवर्ड गलत छ",
    article6_sub2_dec2: "यदि तपाइँ यहाँ आवेदन गर्नुहुन्छ भने, हामी परीक्षाको दिन, परीक्षा मूल्य, र मूल्य घोषणा गर्ने छौं।",
    create_naw_password: "पासवर्ड परिवर्तन गर्नुहोस्",
    send_confirmcode: "एक प्रमाणिकरण कोड पठाइएको छ",
    edit: "परिवर्तन",
    success_new_password_setting: "तपाईंले नयाँ पासवर्ड सेट गर्नुभयो।",
    error_email: "यो दर्ता नगरिएको ईमेल ठेगाना हो।",

    click_here_businesses: "व्यवसायका लागि यहाँ क्लिक गर्नुहोस्",
    regist_organization_staff_info: "व्यवसाय / प्रयोगकर्ता जानकारी को पंजीकरण",
    organization_info: "ब्यापार जानकारी",
    staff_info: "प्रयोगकर्ता-जानकारी",
    org_name: "व्यापारिक नाम",
    url: "URL",
    org_scale: "स्केल",
    org_zip: "हुलाकी कोड",
    org_adress1: "प्रान्तहरू",
    org_adress2: "नगरपालिका",
    org_adress3: "ठेगाना / अपार्टमेन्ट नाम",
    org_industry: "उद्योग",
    org_category: "कोटि",
    org_description: "वर्णन",
    org_established_at: "स्थापना को वर्ष",
    org_phone: "व्यवसाय फोन नम्बर",
    failed_established_at: "अवैध मिति।",
    staff_name: "प्रयोगकर्ता नाम",
    form_miss: "इनपुट फारममा एक गल्ती छ।",
    back_joboffer_detail: "काम विवरणमा फर्कनुहोस् <",
    create_joboffer: "काम सिर्जना गर्नुहोस्",
    edit_joboffer: "कार्य सम्पादन गर्नुहोस्",
    stop_posting: "पोष्ट गर्न रोक्नुहोस्",
    delete: "मेटाउन",
    job_title: "कार्य शीर्षक",
    job_catch_phrase: "काम पकड वाक्यांश",
    job_category: "व्यवसाय कोटी",
    employed_company_name: "रोजगार कम्पनी नाम",
    work_location: "कार्य स्थान",
    employment_status: "रोजगारी अवस्था",
    full_time_employee: "पूर्ण-समय कर्मचारी",
    part_time_job: "आंसिक काम",
    temporary_staff: "पठाइएको श्रम",
    contract_employee: "ठेका कर्मचारी",
    intern: "इंटर्न",
    subcontracting: "उप-अनुबन्ध",
    contract: "सम्झौता",
    new_graduate: "नयाँ स्नातक",
    salary: "तलब",
    annual_income: "वार्षिक आय",
    monthly_salary: "मासिक तलब",
    weekly_salary: "साप्ताहिक तलब",
    dayly_salary: "दैनिक तलब",
    job_offer_attension1: "कानूनको बमोजिम कार्य सामग्रीका लागि तोकिरहेका कामका सर्तहरू, इत्यादि स्पष्ट रूपमा दर्साउनु आवश्यक छ।",
    job_offer_attension2: "कृपया कार्य स्थितिहरू आदि जाँच गर्नुहोस् जुन कानून द्वारा स्पष्ट रूपमा वर्णन गर्नु आवश्यक छ, र त्यसपछि कार्य सामग्री वर्णन गर्नुहोस्। (सन्दर्भ: स्वास्थ्य, श्रम र कल्याण मन्त्रालय, प्रिफेक्चुरल लेबर ब्यूरो &quot;कामदार भर्ती गर्ने सबै कम्पनीहरूलाई&quot;)",
    job_offer_attension3: "कार्यहरू पोस्ट गर्न सकिदैन यदि तपाईं भाषा प्रयोग गर्नुहुन्छ जुन लक्षित व्यक्तिको उमेर, लि gender्ग, वा सामाजिक स्थिति सीमित गर्दछ।",
    job_offer_attension4: "अक्सर अप्रकाशित उदाहरणहरू: &quot;२०s मा स्वागत छ&quot; &quot;युवाहरुलाई स्वागत छ (युवा मानिसहरु)&quot; &quot;महिलाले स्वागत / सीमित&quot; &quot;विद्यार्थी मात्र&quot;",
    work_content_appeal: "कार्य सामग्री र अपील पोइन्टहरू",
    work_content_appeal_desc: "यदि तपाईंले तिनीहरूलाई पहिले अपील पोइन्टहरू भन्नु भयो भने रोजगार खोज्नेहरूको लागि चासो लिन सजिलो हुनेछ।",
    human_resources_seek: "मानवीय संसाधन",
    human_resources_seek_desc: "तपाईले खोज्नु भएको दक्षता मात्र नभएर जानकारी पनि प्रदान गर्नुहोस् जसले काम खोजी गर्नेहरूले कार्यस्थलको कल्पना गर्न दिन्छ।",
    working_hours: "कामका घण्टा",
    traffic_access: "यातायात पहुँच",
    traffic_access_desc: "सार्वजनिक यातायात सम्बन्धी जानकारीको साथसाथै कारबाट यात्रा गर्दा र त्यहाँ कामदारहरूको लागि पार्कि lot छ वा छैन जस्ता जानकारी समावेश गर्नुहोस्।",
    required: "अनिवार्य",
    optional: "कुनै",
    other: "अन्य",
    photo: "फोटो",
    upload_video: "भिडियो अपलोड गर्नुहोस्",
    job_tag: "कार्य ट्यागहरू",
    until_select_three: "To सम्ममा चयन गर्न सकिन्छ",
    senior_support: "वरिष्ठ समर्थन",
    salary_increase_promotion: "त्यहाँ एक तलब वृद्धि / पदोन्नति छ",
    no_overtime: "ओभरटाइम छैन",
    target_hiring_time: "लक्ष्य भाडामा लिने समय",
    additional_questions: "थप प्रश्नहरू",
    job_offer_title: "कामको नाम",
    public: "रिलिज",
    private: "निजी",
    public_status: "सार्वजनिक स्थिति",
    occupation: "पेशा",
    walfare: "उपचार / कल्याण",
    create: "सिर्जना गर्नुहोस्",
    hour: "समय",
    back_mypage: "मेरो पृष्ठ <मा फर्कनुहोस्",
    job_offers: "कार्य सूची",
    look_matches: "मिलान सूची हेर्नुहोस्",
    now_public: "अब खोल्नुहोस्",
    now_private: "निजी",
    check: "पुष्टि गर्नुहोस्",
    edit2: "सम्पादन गर्न",
    news_detail: "समाचार विवरण",
    prefectures: "प्रान्तहरू",
    hokkaido: "होक्काइडो",
    aomori: "अओमोरी",
    iwate: "Iwate",
    miyagi: "मियागी",
    akita: "अकिता",
    yamagata: "यामगाता",
    fukushima: "फुकुशिमा",
    ibaraki: "Ibaraki",
    tochigi: "तोचिगी",
    gunma: "गुन्मा",
    saitama: "सैतामा",
    chiba: "चिबा",
    tokyo: "टोकियो",
    kanagawa: "कानगावा",
    niigata: "निगाटा",
    toyama: "तोयामा",
    ishikawa: "ईशिकावा",
    fukui: "फुकुइ",
    yamanashi: "यामानशी",
    nagano: "नागानो",
    gifu: "Gifu",
    shizuoka: "Shizuoka",
    aichi: "आइची",
    mie: "ट्रिपल",
    shiga: "शिगा",
    kyoto: "क्योटो",
    osaka: "ओसाका",
    hyogo: "Hyogo",
    nara: "नारा",
    wakayama: "वाकायामा",
    tottori: "टोटोरी",
    shimane: "Shimane",
    okayama: "Okayama",
    hiroshima: "हिरोशिमा",
    yamaguti: "यामागुची",
    tokushima: "टोकुशिमा",
    kagawa: "कागवा",
    echime: "Ehime",
    kochi: "कोची",
    fukuoka: "फुकुओका",
    saga: "सागा",
    nagasaki: "नागासाकी",
    kumamoto: "कुमामोटो",
    oita: "Oita",
    miyazaki: "मियाजाकी",
    kagoshima: "कागोशिमा",
    okinawa: "ओकिनावा",
    sinhalese: "सिंहला",
    exam_region: "प्रान्तहरू",
    exam_place_list: "स्थान सूची",
    exam_place_name: "परीक्षा स्थल नाम",
    care_evaluation_test: "दीर्घकालीन देखभाल कौशल प्रशिक्षण मूल्यांकन परीक्षण",
    clean_building_test: "भवन सफाई उद्योग विगतका समस्याहरू",
    answer: "उत्तर",
    skill_test_measurement: "कौशल मापन परीक्षण",
    exam_problem: "परीक्षाको प्रश्न",
    fields: "क्षेत्र र तरकारीहरू",
    gardening: "सुविधा बागवानी",
    mushroom: "च्याउ",
    fruit: "फल रूख",
    dairy: "दुग्ध",
    poultry: "कुखुरा पालन",
    pig: "सुँगुर खेती",
    beginner: "बिगिनर",
    professional: "प्रोफेशनल ग्रेड",
    advanced: "उन्नत",
    technical_training_test: "प्राविधिक इंटर्न प्रशिक्षण मूल्यांकन परीक्षण",
    exam_part: "परीक्षा प्रश्नहरूको भाग",
    tokoha_fruit: "टोकहाहा फलफूल",
    deciduous_fruit: "पातलो फल रूख",
    ver: "संस्करण",
    errata: "इरटा",
    form_work: "फॉर्मवर्क निर्माण",
    construction: "प्लास्टरर",
    tunnel_line: "सुरुnel प्रणोदन रेखा",
    earth_work: "अर्थवर्क",
    loofing: "छत",
    elecommunication: "दूरसंचार",
    reinforcing_contstruction: "पट्टी निर्माण सुदृढ गर्दै",
    reinforcing_joint: "प्रबल पट्टी संयुक्त",
    wall_painting: "चित्रकारी (भित्ता ढाक्न)",
    board_finish: "बोर्ड समाप्त, आन्तरिक समाप्त",
    steeplejack: "जम्प",
    spray_insulation: "स्प्रेड युरेथेन इन्सुलेशन",
    marine_civil: "समुद्री सिभिल इन्जीनियरिंग",
    concrete_pumping: "कंक्रीट पम्पिंग",
    construction_machinery: "निर्माण मेसिनरी निर्माण",
    learning_text: "पाठ सिक्दै",
    basic_aircraft: "विमान आधारभूत प्रविधि निष्कर्ष, विद्युतीय मापन",
    worksafety_quality: "कार्य सुरक्षा, गुणवत्ता",
    aircraft_overview: "विमान अवलोकन",
    fish_general: "सामान्यतया माछा पालन",
    fish_safety: "मत्स्य सुरक्षा",
    network_relations: "माछा पालन विशेष डोरी सम्बन्ध",
    fish_relations: "माछा पालन विशेष माछा मार्ने सम्बन्धित",
    aquaculture_general: "सामान्यतया एक्वाकल्चर",
    feeding_aquaculture: "एक्वाकल्चर विशेषता फीडिंग एक्वाकल्चर",
    unfed_aquaculture: "एक्वाकल्चर विशेषता अनफिड एक्वाकल्चर",
    attachment: "संलग्नक",
    glossary: "शब्दावली",
    feneral_customer: "सामान्य ग्राहक सेवा",
    food_dring_cooking: "खाना र पेय पकाउने",
    hygiene_management: "सरसफाइ व्यवस्थापन",
    visa_application: "विशिष्ट कौशल भिसा आवेदन",
    certificate_residence_tax: "१. निवास कर को प्रमाणपत्र (पछिल्लो वर्ष को लागी)",
    salary_income_withholding : "२. तलब आयका लागि होल्डिंग स्लिपको प्रतिलिपि",
    national_health_insured: "The. राष्ट्रिय स्वास्थ्य बीमा बीमाकृत व्यक्तिको कार्डको प्रतिलिपि (यदि व्यक्ति दर्ता गरिएको छ भने)",
    national_health_payment: "National. राष्ट्रिय स्वास्थ्य बीमा प्रीमियम भुक्तान प्रमाणपत्र",
    national_health_receipt: "National. राष्ट्रिय स्वास्थ्य बीमा प्रीमियम रसीदको एक प्रति",
    technical_intern_training2: "Technical. प्राविधिक इन्टर्नल तालिम नं २ लाई प्रमाणित गर्ने कागजातहरू सफलतापूर्वक समाप्त भयो",
    need_the_following : "तपाईंलाई निम्न मध्ये एक चाहिन्छ:",
    pass_certificate_test_specialized : "Evalu कौशल मूल्यांकन परीक्षणको व्यावहारिक कौशल परीक्षणको पास पास प्रमाणपत्रको एक प्रतिलिपि (विशेष ग्रेड)",
    technical_intern_training3: "The कौशल परीक्षणको व्यावहारिक परीक्षणको पास प्रमाणपत्रको प्रतिलिपि (grade कक्षा)",
    evaluation_record_technical_intern: "You यदि तपाईं माथिको परीक्षा पास गर्नुहुन्न भने, तपाईंले टेक्निकल इन्टर्न प्रशिक्षुको लागि मूल्यांकन रेकर्ड भर्नु पर्छ।",
    cartificate_pass_basic_test: ".6..6 को विकल्पको रूपमा, तपाईं जापान फाउन्डेसन जापानी आधारभूत टेस्टको पास प्रमाणपत्रको प्रतिलिपि वा जापानी भाषा प्रवीणता टेस्ट (N4) वा उच्चको पास प्रमाणपत्रको प्रतिलिपि सबमिट गर्न सक्नुहुन्छ।",
    change_permission_application: "Change. परिवर्तन अनुमति अनुप्रयोगको तस्वीर (ठाडो cm सेमी x तेर्सो cm सेमी)",
    resume_data_time_entry: "Entry। प्रवेशको समयमा डाटा पुनःसुरु गर्नुहोस्",
    select_file: "फाईलहरू चयन गर्नुहोस्",

    description_movie: "स्पष्टीकरण भिडियो",
    how_to_use_movie: "भिडियो कसरी प्रयोग गर्ने",
    movie_news: "१. विशिष्ट कौशल भिसाको बारेमा समाचार",
    movie_exam: "२. परीक्षण मिति सम्म बाँकी दिनहरूको संख्या",
    movie_predict_pass: "Pass. अनुमानित पास दर",
    movie_ave_study_test: "You. तपाईंले अध्ययन गर्नुभएको आफ्नै परीक्षणको औसत स्कोर",
    movie_similar_exam: "Similar. समान परीक्षा प्रश्नहरू",
    movie_learning_text: "The. सिक्ने पाठ्य पुस्तक (पाठ्यपुस्तक) डाउनलोड गर्नुहोस्",
    movie_solved_exam: "Pro. समस्याहरू मैले विगतमा समाधान गरे",
    movie_pased_exam: "Past. विगतका समस्याहरू वास्तवमै देखापर्ने बारेमा",
    movie_resume_regist: "Registration। प्रवेशको समयमा दर्ता पुनः सुरु गर्नुहोस्",
    movie_pass_document_regist: "१०. प्रवीणता परीक्षा पासको पंजीकरण",
    movie_agency_service: "११. परीक्षा आवेदन एजेन्सी सेवा",
    movie_consule_service: "१२. परामर्श सेवा सिक्दै",
    description_movie_trans: "यदि तपाईं जापानीज बाहेक कुनै भाषामा हेर्न चाहानुहुन्छ भने गियर मार्कमा क्लिक गर्नुहोस्, उपशीर्षकहरू र स्वचालित अनुवाद क्लिक गर्नुहोस्, तपाईंको मातृभाषा चयन गर्नुहोस् र त्यसपछि हेर्नुहोस्।",


"cultivated_agriculture_general": "समग्र खेति कृषि ",
"livestock_agriculture": "पशुपालन कृषि",
"介護": "नर्सिङ/हेरचाह ",
"ビルクリーニング": "भवन सरसफाई",
"建設": "निर्माण",
"自動車整備": "गाडी  मर्मतसम्भार",
"航空業": "उड्डयन उद्योग",
"農業": "कृषि",
"漁業": "माछा उद्योग (पालन तथा मार्ने )",
"飲食料品製造業": "खाद्य र पेय पदार्थ उत्पादन उद्योग",
"外食業": "रेस्टुरेन्ट व्यवसाय",
"型枠施工": "आकार  निर्माण (Formwork)",
"左官": "प्लास्टर",
"コンクリート圧送": "कंक्रीट पम्पिङ",
"トンネル推進工": "टनेल प्रोपल्सन कार्य",
"建設機械施工": "निर्माण मेसिन प्रयोग गरि गरिने कार्य ",
"大工": "सिकर्मी",
"屋根ふき": "छत",
"電気通信": "दूरसञ्चार",
"鉄筋施工": "मझभुत  बार निर्माण (फलाम हरु प्रयोग गरेर निर्माण गरिने )",
"鉄筋継手": "फलाम जोड्ने कार्य",
"壁装（壁張り）": "पर्खाल ढाक्ने (भित्ता ढाक्ने)",
"ボード仕上げ、内装仕上げ": "बोर्ड फिनिशिंग , भित्रि भाग /इन्टेरिअर फिनिशिंग ",
"とび": "भवन निर्माणमा प्रोयोग गरिने फलामे छड(Scaffolding )",
"吹き付けウレタン断熱": "स्प्रेजडित यूरेथेन इन्सुलेशन ",
"海洋土木工": "समुद्री सिभिल ईन्जिनियरिङ्/निर्माण ",
"航空機の基本技術 締結、電気計測": "विमान आधारभूत प्रविधि निष्कर्ष, बिधुतिय  मापन",
"作業安全、品質": "कामको सुरक्षा, गुणस्तर",
"航空機概要": "विमान अवलोकन/परिचय ",
"耕種農業全般": "समग्र खेति कृषि",
"畜産農業": "पशुपालन कृषि",
"漁業一般": "सामान्य माछा मार्ने",
"漁業安全": "मत्स्य पालन सुरक्षा",
"漁業専門 綱関係": "मत्स्य पालन विशेष डोरी सम्बन्ध",
"漁業専門 釣り関係": " माछा मार्ने मा विशेषज्ञता",
"養殖業一般": "सामान्य  एक्वाकल्चर",
"養殖業専門 給餌養殖関係": "एक्वाकल्चर विशेष फिडिंग एक्वाकल्चर",
"養殖業専門 無給餌養殖関係": "एक्वाकल्चर विशेष अनफिड एक्वाकल्चर",
"接客全般": "सामान्य ग्राहक सेवा",
"飲食物調理": "खाना र पेय खाना पकाउने",
"衛生管理": "स्वच्छता/हाइजिन  व्यवस्थापन",
"日本語版": "जापानी संस्करण",
"英語版": "अंग्रेजी संस्करण",
"クメール語版": "खमेर संस्करण",
"インドネシア語版": "इन्डोनेसियाली संस्करण",
"インドネシア語・正誤表": "इन्डोनेसियाली भाषा,  ठिक /त्रुटि तालिका",
"ネパール語版": "नेपाली संस्करण",
"モンゴル語版": "मङ्गोलियन संस्करण",
"ビルマ語版": "बर्मी संस्करण",
"ベトナム語版": "भियतनामी संस्करण",
"タイ語版": "थाई संस्करण",
"テキスト１": "पाठ्यपुस्तक  १",
"テキスト２": "पाठ्यपुस्तक २",
"テキスト３": "पाठ्यपुस्तक ३",
"テキスト４": "पाठ्यपुस्तक ४",
"テキスト５": "पाठ्यपुस्तक ५",
"ミャンマー(ビルマ)語版": "म्यानमार (बर्मी) भाषा संस्करण",
"カンボジア(クメール)語版": "कम्बोडिया (खमेर) भाषा संस्करण",
"ミャンマー語版": "बर्मी(म्यान्मार) संस्करण",
"中国語版": "चिनियाँ संस्करण",
"付属資料": "संलग्नक(सम्लंग कागजात)",
"用語集": "शब्दावली",

invitation_code: "निमन्त्रणा कोड",
exam_calender: "परीक्षा तालिका क्यालेन्डर",
move_exam_detail: "के तपाई परीक्षा तालिका विवरण पृष्ठमा जान चाहनुहुन्छ?",
move: "सार्दै",
plece_select_language: "कृपया एउटा भाषा चयन गर्नुहोस्",
select: "चयन गर्नुहोस् (छान्नुहोस् )",
midle_category: "पेशा",
select_industry_description: "सुरुमा, AELU ३ उद्योगहरू सम्म  मात्र छनौट  गर्न सकिने हुन्छ , त्यसैले तपाईंले काम गर्न चाहनुभएको उद्योग मात्र चयन गर्नुहोस्। यदि यो ठीक देखिन्छ भने, अर्को बटम थिच्नुहोस्",
done_member_regist_description_2: "अब देखि, हामी धेरै प्रमाणीकरण परीक्षाहरू तयारी गरेर एक विशिष्ट कौशल भिसा प्राप्त गर्न AELU ले पनि सपोर्ट गर्नेछौं ।",
done_member_regist_2: "सदस्यता  दर्ता पूरा भयो ।",
is_exist_user: "उही इमेल ठेगाना भएको प्रयोगकर्ता पहिले नै अवस्थित छ।",
invitation_code_description: "(कृपया पठाउने संस्था वा जापानी भाषा विद्यालयबाट प्राप्त निमन्त्रणा कोड प्रविष्ट गर्नुहोस्, अन्यथा खर्चभुक्तान  स्क्रिन देखा पर्नेछ, त्यसैले  प्रविष्ट गर्न नबिर्सनुहोस्।)",
pleace_select_region: "कृपया होस्ट प्रिफेक्चर चयन(छनौट ) गर्नुहोस्",
pleace_add_messenger: "सबै खबरहरु  फेसबुक मेसेजर मार्फत पठाइनेछ त्यसैले अनिबार्य  जोडिनुहोस्/साथि भएको निश्चित गर्नुहोस ",
add_messenger_bot: "सूचनाहरू प्राप्त गर्नु",
visa_application_description: "विशिष्ट कौशल भिसाको लागि आवेदन समय ,  आवश्यक कागजात भण्डारण स्थान",
check_agree: "कृपया सहमत हुनुहोस्",
sample_title: "यो डमी (नक्कली ) शीर्षक हो। कृपया सेट गर्नुहोस्",
sample_description: "यो  डमी  (नक्कली )विवरण हो। कृपया सेट गर्नुहोस्। यो डमी (नक्कली )विवरण हो। कृपया सेट गर्नुहोस्। यो डमी (नक्कली )विवरण हो। कृपया सेट गर्नुहोस्। यो डमी (नक्कली )विवरण हो। कृपया सेट गर्नुहोस्। यो डमी (नक्कली )विवरण हो। कृपया सेट गर्नुहोस्। यो डमी (नक्कली )विवरण हो। कृपया सेट गर्नुहोस्।",
create_profile_error: "इनपुट(प्रबिस्टी)मा त्रुटि छ। कृपया आइटम  (बिषय ) जाँच गर्नुहोस्",
setting_confirm: "कृपया इनपुट(प्रबिस्टी)  बिबरण पुष्टि (चेकजाच )गरेर दर्ता गर्नुहोस्",
exam_learning: "परीक्षा सिकाइ(अध्ययन)",
recommend_problem_solve: "समान किसिमका परीक्षा प्रश्नहरू समाधान गर्नुहोस्",
of: "को",
see_solved_problem: "तपाईंले विगतमा समाधान गर्नुभएको समस्याहरू समाधान गर्नुहोस् ",
past_exam_collection: "विगतमा आएका परीक्षा प्रश्नहरू",
any_application_registration: "विभिन्न आवेदन दर्ता",
mypage_visa_application: "विशिष्ट कौशल भिसा आवेदन",
applyt_exam_and_agent: "परीक्षा आवेदन \n एजेन्सी सेवा आवेदन",
myapge_regist_accept_certificate: "सीप परीक्षण परीक्षा \n पासप्रमाणपत्रको दर्ता",
mypage_consultaion_service: "सिकाइ (अध्ययन)परामर्श \n सेवा",
consultaion_service: "सिकाइ (अध्ययन)परामर्श सेवा",
consult: "परामर्श",
of_exam_day: "...को परीक्षा मिति",
your_ave_score: "तपाईको परीक्षणको औसत स्कोर(अंक )",
your_estimated_pass_rate: "तपाईंको निश्चित भएको  पास दर",
your_ave_score_fotter: "तपाईको परीक्षणको  औसत स्कोर",
your_estimated_pass_rate_fotter: "निश्चित भएको  पास दर",
mypage_study_text: "सिकाइ पाठ्यपुस्तक डाउनलोड ",
exam_schedule: "परीक्षा तालिका",
resident_caption_title: "● निवास कार्ड वा परिचय पत्र अपलोड गर्ने बारे",
resident_caption: "कृपया रातो फ्रेममा जानकारी पुष्टि गर्न सक्ने निवास कार्ड वा आईडी कार्ड अपलोड गर्नुहोस्। कृपया म्याद नसकिएको वैध निवास कार्ड वा परिचयपत्र अपलोड गर्नुहोस्। PDF वा JPG ढाँचामा रंगिन इमेज अपलोड गर्नुहोस्।।",
password_caption_title: "● पासवर्ड अपलोड गर्ने बारे",
password_caption: "कृपया रातो फ्रेममा देखाइए अनुसार तपाईंको नाम \n फोटो \n पासपोर्ट  नम्बर \n जन्म मिति \n राष्ट्रियता \n समाप्ति मिति पुष्टि गर्ने पासपोर्ट को इमेज अपलोड गर्नुहोस्। कृपया म्याद नसकिएको वैध राहदानी(पासपोर्ट) अपलोड गर्नुहोस्। PDF वा JPG ढाँचामा रंगिन इमेज अपलोड गर्नुहोस्।",
title_help: "मद्दत",
step3_title_help: "कृपया आफ्नो जानकारी सही रूपमा प्रविष्ट गर्नुहोस्।",
lineid_input_help: "LINE खोलेर LINE → Home → Settings → Profile → Scroll गरेमा ID देखिनेछ । कृपया त्यो ID प्रविष्ट गर्नुहोस्। यदि तपाईंले यसलाई (ID)सिर्जना गर्नुभएको छैन भने, कृपया यसलाई सिर्जना गर्नुहोस् र  प्रविष्ट गर्नुहोस्।",
country_input_help: "कृपया आफ्नो राष्ट्रियताको देश चयन गर्नुहोस्।",
area_input_help: "तपाईं हाल बस्नुभएको आफ्नो क्षेत्रको देश चयन गर्नुहोस्।",
phone_input_help: "कृपया आफ्नो फोन नम्बर प्रविष्ट गर्नुहोस्।",
issuing_input_help: "कृपया आफ्नो आईडी जारी गरिएको क्षेत्र चयन गर्नुहोस्।",
idtype_input_help: "कृपया एउटा ID प्रकार चयन गर्नुहोस्। कृपया चयन गरिएको व्यक्तिको राम्रोसंग तस्वीर लिनुहोस् र अपलोड गर्नुहोस्। कृपया सीधा शूट गर्नुहोस् ताकि त्यहाँ कुनै बांगो  वा काटिएको भागहरु  छैनन्।",
invitation_input_help: "यदि तपाइँसँग निमन्त्रणा कोड छ भने, यसलाई प्रविष्ट गर्नुहोस्।",
exam_menu_help: "त्यहाँ विगतमा सोधिएका प्रश्नहरू जस्तै प्रश्नहरू हुनेछन्। परीक्षाको तयारी गर्न बारम्बार प्रश्नहरू समाधान गर्नुहोस्।",
past_menu_help: "तपाईंले विगतमा समाधान गरेका समस्याहरू हुनेछन्। गल्तीहरू भएको ठाउँ पत्ता लगाई समिक्ष्या गरौँ ।",
pastexam_menu_help: "यो वास्तवमा विगतमा भएका परीक्षा प्रश्नहरूको पाठ हो।",
text_menu_help: "तपाईंले महत्त्वपूर्ण बुँदाहरू अध्ययन गर्न र तपाईंले नबुझेको कुरा पत्ता लगाउन अध्ययन पाठ्यपुस्तकहरू हेर्न सक्नुहुन्छ।",
visa_menu_help: "हामी तपाईंलाई एक विशेष कौशल भिसा प्राप्त गर्न मद्दत गर्नेछौं। विशेष सीपको लागि भिसा प्राप्त गर्न चाहनुहुने व्यक्तिले कृपया यहाँ बाट आवेदन गर्नुहोस्।",
agency_menu_help: "हामी तपाईंको तर्फबाट विशेष कौशल परीक्षा को लागि आवेदन दिनेछौं। यदि तपाइँ एक विशेष कौशल परीक्षा  लिन चाहनुहुन्छ भने, कृपया यहाँ आवेदन गर्नुहोस्।",
cer_menu_help: "यदि तपाईंले विशेष कौशल परीक्षा दिनुभएको छ र पास प्रमाणपत्र छ भने, कृपया यहाँ दर्ता गर्नुहोस्।",
service_menu_help: "यदि तपाइँसँग कुनै प्रश्न वा नबुझेको कुराहरु छ भने, कृपया हामीलाई यहाँ च्याट मार्फत सम्पर्क गर्नुहोस्।",
occu_title_help: "कृपया आफुले चाहेको ३ ओटा पेशा सम्म छनौट गर्नुहोस्।",
back: "फर्किनु",
before: "अघिल्लो समस्यामा",
srilank: "श्रीलंका",
reselect: "यदि तपाइँ फाइल परिवर्तन गर्न चाहनुहुन्छ भने, &quot;आफ्नो राहदानी अपलोड गर्नुहोस्&quot; थिच्नुहोस् र फेरि चयन गर्नुहोस्",
iphone_file: "आईफोनको लागि, कृपया HEIC फाइलबाट JPG फाइलमा रूपान्तरण गरेपछि प्रयोग गर्नुहोस्।",
file_transmit: "फाइलहरू रूपान्तरण गर्नुहोस्",
combodia: 'combodia',
}
